module.exports = __webpack_public_path__ + "static/media/cartao-visita-medcopa1.f0130537.jpg";